
import {env} from '../utils/functions'
//const uploadImg ='http://public.dev.klsfood.cn';
export default{
 apiUrl : env('REACT_APP_IMG_URL')
}